module.exports = __webpack_public_path__ + "img/image-6.d378f98f.png";